import React, { createContext, useContext, useEffect, useState } from "react";

const API = "https://backend-ged-immo.onrender.com";

// Valeurs par défaut identiques à celles de PlateformeSite
export const DEFAULT_SITE_CONFIG = {
  hero: {
    title: "SCI MAYEDO",
    subtitle: "La gestion immobilière professionnelle à votre service",
    cta_label: "Découvrir nos biens",
    cta_url: "/louer",
    background_color: "#1B4F9E",
  },
  about: {
    title: "À propos de SCI MAYEDO",
    text: "Créée en Côte d'Ivoire en 2022, SCI MAYEDO est dirigée par une équipe compétente, jeune, dynamique et disponible à tout moment afin de répondre aux attentes de la clientèle.",
    founded: "2022",
    address: "Cocody Angré 7ème Tranche / Abidjan – Plateau – 01 BP 2076 Abidjan 01",
    slogan: "Votre partenaire de confiance",
  },
  services: {
    list: [
      { title: "Location résidentielle", description: "Appartements et villas pour particuliers.", icon: "fa-house" },
      { title: "Location commerciale",    description: "Bureaux et locaux commerciaux.",           icon: "fa-building" },
      { title: "Gestion locative",        description: "Gestion complète de vos biens.",           icon: "fa-file-contract" },
      { title: "Conciergerie",            description: "Services de conciergerie haut de gamme.",  icon: "fa-concierge-bell" },
    ],
  },
  contact: {
    phone:    "+225 07 77 88 00 82",
    email:    "sci@mayedo.ci",
    address:  "Cocody Angré 7ème Tranche / Abidjan – Plateau – 01 BP 2076 Abidjan 01",
    whatsapp: "2250777880082",
    hours:    "Lun–Ven 08h–17h, Sam 09h–13h",
  },
  social: {
    facebook:  "https://www.facebook.com/profile.php?id=100095004018722&mibextid=JRoKGi",
    instagram: "https://www.instagram.com/doumbia_fode_",
    linkedin:  "",
    twitter:   "",
    youtube:   "",
  },
  seo: {
    site_name:   "SCI MAYEDO",
    site_url:    "https://scimayedo.ci",
    description: "SCI MAYEDO – Gestion et location immobilière professionnelle en Côte d'Ivoire.",
    keywords:    "immobilier, location, appartement, villa, Abidjan, Côte d'Ivoire",
    og_image:    "/images/27.png",
  },
  marquee: {
    enabled:    true,
    text:       "🏠 Bienvenue chez SCI MAYEDO — Votre partenaire immobilier de confiance en Côte d'Ivoire · Villas, Appartements, Bureaux disponibles · Contactez-nous au +225 07 77 88 00 82",
    speed:      40,
    bg:         "#1B4F9E",
    color:      "#ffffff",
  },
};

const SiteConfigContext = createContext({ config: DEFAULT_SITE_CONFIG, loading: true });

export function SiteConfigProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT_SITE_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/site-config`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data?.config && Object.keys(data.config).length > 0) {
          // Merge profond : préserve les defaults pour les clés non configurées
          setConfig((prev) => {
            const merged = { ...prev };
            Object.keys(data.config).forEach((section) => {
              if (data.config[section] && typeof data.config[section] === "object") {
                merged[section] = { ...prev[section], ...data.config[section] };
              }
            });
            return merged;
          });
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <SiteConfigContext.Provider value={{ config, loading }}>
      {children}
    </SiteConfigContext.Provider>
  );
}

export function useSiteConfig() {
  return useContext(SiteConfigContext);
}
